module.exports = __webpack_public_path__ + "assets/a-2-kouzhao.635ec9c9.svg";